import { Backdrop, Box, CircularProgress, FormControlLabel, InputAdornment, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { AxiosError } from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as constants from "../../../constants";
import ContainedButton from "../../../shared/Button/CustomContainedButton";
import OutlinedButton from "../../../shared/Button/customOutlinedButton";
import CustomDatePicker from "../../../shared/CustomDate";
import CustomTextField from "../../../shared/CustomTextFeild";
import { RootState } from "../../../store/store";
import basestyle from "../../CSS/Base.module.css";
import CancelPopUp from "../../PopUp/PopUp";
import {
    getBRPdfByYearAndLocation,
    getBudgetDocumentDetailsByYearAndLocationId,
    getBudgetForecastEligibleYearByParticipantIdAndYear,
    getDetailsByTypeYear,
    getDetailsByYearandLocationId,
    saveActualDetails
} from "../services/Financials/budget.service";
import { CoverSheetActualVO } from "../services/Financials/financials";
import {
    SectionTitle,
    StyledInputLabel,
    StyledOneChildContainer,
    StyledParentContainer,
    StyledTwoChildContainer,
    SubSectionTitle,
} from "../StyledComponents/Container";
import { formatCurrencywithoutDoller } from "../Utils/formatUtils";
import { notifyUser } from "../Utils/notifyUser";

const BudgetReportView: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [openPopUp, setOpenPopUp] = useState(false);

    // State hooks for various values   
    const [coverSheetActualVO, setCoverSheetActualVO] = useState<any[]>([]);
    const participantDetail = useSelector((state: RootState) => state.participantDetails);
    const [loadingFlag, setLoadingFlag] = useState(false);
    const [financialYear, setFinancialYear] = useState(0);
    const [documentShowFlag, setDocumentShowFlag] = useState<boolean>(false);
    const userDetails = useSelector((state: RootState) => state.auth);
    const [rowData, setRowData] = useState<any>(location.state?.rowData ?? {});
    const { t } = useTranslation();
    const translate = t as (key: string) => string;
    const [readOnlyForecast, setReadOnlyForecast] = useState(false);

    const [sectionVOList, setSectionVOList] = useState<any[]>([]);
    const forecastYear = rowData?.forecastYear ?? "";
    const [showMessage, setShowMessage] = useState<boolean>(false);
    const [participantId, setParticipantId] = useState<number>(0);
    const [participantType, setParticipantType] = useState("");

    const handleBack = () => {
        navigate("/budgetListing");
    };

    function createActualObject(locationId: number, year: string, fieldId: number, value: any): CoverSheetActualVO {
        return {
            id: 0,
            locationId,
            year,
            fieldId,
            clientId: userDetails.clientId,
            value,
            isActive: constants.IS_ACTIVE_YES,
        };
    }


    async function handleSave() {
        setLoadingFlag(true);

        try {
            const actualList = [];
            const userEmail = userDetails.emailId;
            if (coverSheetActualVO && coverSheetActualVO.length > 0) {
                for (const section of sectionVOList) {
                    for (const sectiondetails of section.coverSheetMetadataSectionDetails || []) {
                        if (Array.isArray(sectiondetails.childDetails) && sectiondetails.childDetails.length > 0) {
                            for (const child of sectiondetails.childDetails) {
                                const actual = coverSheetActualVO.find(x => x.fieldId === child.id);
                                if (child.type === "date" && child.value) {
                                    if (actual && actual.value !== child.value.formatted && child.value.formatted) {
                                        actualList.push({
                                            ...actual,
                                            value: child.value.formatted,
                                            lastUpdatedBy: userEmail,
                                            lastUpdatedTime: new Date(),
                                            id: actual.id
                                        });
                                    }
                                } else {
                                    const oldValue =
                                        actual?.value !== undefined && actual?.value !== null
                                            ? parseFloat(actual.value).toFixed(2)
                                            : "";

                                    const newValue =
                                        child?.value !== undefined && child?.value !== null
                                            ? parseFloat(child.value).toFixed(2)
                                            : "";

                                    if (actual && oldValue !== newValue) {
                                        actualList.push({
                                            ...actual,
                                            value: child.value,
                                            lastUpdatedBy: userEmail,
                                            lastUpdatedTime: new Date(),
                                            id: actual.id
                                        });
                                    }
                                }
                            }
                        } else {
                            if (sectiondetails.type) {
                                const actual = coverSheetActualVO.find(x => x.fieldId === sectiondetails.id);

                                if (sectiondetails.type === "date" && sectiondetails.value) {
                                    if (actual && actual.value !== sectiondetails.value.formatted && sectiondetails.value.formatted) {
                                        actualList.push({
                                            ...actual,
                                            value: sectiondetails.value.formatted,
                                            lastUpdatedBy: userEmail,
                                            lastUpdatedTime: new Date(),
                                            id: actual.id
                                        });
                                    }
                                } else {
                                    if (actual && actual.value !== sectiondetails.value) {
                                        actualList.push({
                                            ...actual,
                                            value: sectiondetails.value,
                                            lastUpdatedBy: userEmail,
                                            lastUpdatedTime: new Date(),
                                            id: actual.id
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                for (const section of sectionVOList) {
                    for (const sectiondetails of section.coverSheetMetadataSectionDetails || []) {
                        if (sectiondetails.type && !sectiondetails.childDetails) {
                            if (sectiondetails.type === "date" && sectiondetails.value) {
                                actualList.push(createActualObject(participantId, section.year, sectiondetails.id, sectiondetails.value.formatted));
                            } else {
                                actualList.push(createActualObject(participantId, section.year, sectiondetails.id, sectiondetails.value));
                            }
                        } else if (Array.isArray(sectiondetails.childDetails)) {
                            for (const child of sectiondetails.childDetails) {
                                if (child.type === "date" && child.value) {
                                    actualList.push(createActualObject(participantId, section.year, child.id, child.value.formatted));
                                } else {
                                    actualList.push(createActualObject(participantId, section.year, child.id, child.value));
                                }
                            }
                        }
                    }
                }
            }

            // Save the final list 
            if (actualList?.length > 0) {
                const responseList = await saveActualDetails(actualList);
                if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                    notifyUser(responseList?.data?.message, 'success', translate('budgetReportDetails'));
                    navigate("/budgetListing");
                } else {
                    notifyUser(responseList?.data?.message, 'error', translate('budgetReportDetails'));
                }
            } else {
                notifyUser(constants.ERROR_VALIDATION_MESSAGE_NO_VALUE_HAVE_BEEN_MODIFIED, 'error', translate('budgetReportDetails'));
            }

        } catch (error) {
            // Error handling
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        } finally {
            setLoadingFlag(false);
        }
    }

    async function handlePrint() {
        try {
            const responseList = await getBRPdfByYearAndLocation(forecastYear, participantId, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS && responseList?.data?.data?.contents) {
                const byteArray = new Uint8Array(
                    atob(responseList?.data?.data?.contents)
                        .split("")
                        .map(char => char.charCodeAt(0))
                );

                const file = new Blob([byteArray], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            } else {
                notifyUser(responseList?.data?.message, 'error', translate('budgetReportDetails'));
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }

    const handleCancel = () => {
        setOpenPopUp(true);
    };


    const handlePopUpClose = () => {
        setOpenPopUp(false);
    };

    function handleConfirm() {
        navigate("/budgetListing");
    }

    const unformatCurrencyInput = (value: any) => {
        return value.replace(/,/g, "");
    };
    const handleFieldChange = (
        itemIndex: number,
        fieldName: string,
        value: any
    ) => {
        const updatedSection = [...sectionVOList];
        if (!updatedSection[itemIndex]) return;

        const sectionDetails = updatedSection[itemIndex].coverSheetMetadataSectionDetails;

        if (!Array.isArray(sectionDetails)) return;

        sectionDetails.forEach((field: any) => {
            if (field?.shortName === fieldName) {
                field.value = value;
            }
            if (Array.isArray(field.childDetails)) {
                field.childDetails.forEach((child: any) => {
                    if (child?.shortName === fieldName) {
                        child.value = value;
                    }
                });
            }
        });
        setSectionVOList(updatedSection);
    };
    async function getBudgetForecastEligibleYearInfo() {
        try {
            const responseList = await getBudgetForecastEligibleYearByParticipantIdAndYear(participantId, financialYear, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                setReadOnlyForecast(responseList?.data?.data?.readOnly);
            } else {
                setReadOnlyForecast(false);
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        } finally {
        }
    }


    useEffect(() => {
        if (userDetails.defaultParticipantId) {
            setParticipantId(userDetails.defaultParticipantId);
            const participant = (participantDetail.participantsArray as { participantId: string; participantType: string }[]).find((item) => item.participantId === userDetails.defaultParticipantId);
            setParticipantType(participant?.participantType ?? "")
        }
    }, [userDetails.defaultParticipantId]);
    useEffect(() => {
        if (forecastYear) {
            if (forecastYear && forecastYear.length === 4) {
                const currentYear = parseInt(forecastYear.substring(2, 4)) + 2000;
                setFinancialYear(currentYear);
            }
        }
    }, [forecastYear]);

    useEffect(() => {
        if (participantId && financialYear) {
            getBudgetForecastEligibleYearInfo();
            getBudgetDocumentDetails();
        }
        if (participantId) {

        }
    }, [participantId, financialYear]);


    useEffect(() => {
        if (forecastYear && participantType) {
            getDetailsByTypeYearInfo();
        }
    }, [forecastYear, participantType]);

    useEffect(() => {
        if (sectionVOList.length > 0) {
            getBudgetReport();
        }

    }, [sectionVOList.length > 0]);



    async function getDetailsByTypeYearInfo() {
        try {
            const responseList = await getDetailsByTypeYear(forecastYear, participantType, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                if (responseList?.data?.data?.sectionVOList) {
                    setSectionVOList(responseList?.data?.data?.sectionVOList);
                    setShowMessage(false);
                } else {
                    setShowMessage(true);
                }
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }

    async function getBudgetDocumentDetails() {
        try {
            const responseList = await getBudgetDocumentDetailsByYearAndLocationId(forecastYear, participantId, "budget_reports", userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS && responseList?.data?.data?.documentsVOS) {
                setDocumentShowFlag(true);
            } else {
                setDocumentShowFlag(false);

            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }


    async function getBudgetReport() {
        try {
            const responseList = await getDetailsByYearandLocationId(forecastYear, participantId, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                if (responseList?.data?.data?.coverSheetActualVOS != null && responseList?.data?.data?.coverSheetActualVOS.length > 0) {
                    setCoverSheetActualVO(responseList?.data?.data?.coverSheetActualVOS)

                    const updatedSectionVOList = JSON.parse(JSON.stringify(sectionVOList));
                    for (let section of updatedSectionVOList) {
                        for (let sectiondetails of section.coverSheetMetadataSectionDetails) {
                            if (sectiondetails.childDetails != null && sectiondetails.childDetails.length > 0) {
                                for (let child of sectiondetails.childDetails) {
                                    if (child.type != null) {
                                        const obj = responseList.data.data.coverSheetActualVOS.find((x: { fieldId: any }) => x.fieldId == child.id);
                                        child.value = obj?.value ?? "";
                                    }
                                }
                            } else {
                                if (sectiondetails.type != null) {
                                    const obj = responseList.data.data.coverSheetActualVOS.find((x: { fieldId: any }) => x.fieldId == sectiondetails.id);
                                    let fieldvalue: any = obj != null ? obj.value : null;

                                    if (sectiondetails.type === "date" && fieldvalue != null) {
                                        let dDate = new Date(Date.parse(fieldvalue));
                                        fieldvalue = {
                                            date: {
                                                year: dDate.getFullYear(),
                                                month: dDate.getMonth() + 1,
                                                day: dDate.getUTCDate()
                                            }
                                        };
                                    } else if (sectiondetails.type === "date" && fieldvalue == null) {
                                        fieldvalue = {};
                                    }

                                    sectiondetails.value = fieldvalue;
                                }
                            }
                        }
                    }
                    setSectionVOList(updatedSectionVOList);
                }
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }


    return (
        <StyledParentContainer>
            <StyledOneChildContainer>
                <StyledTwoChildContainer sx={{ border: "none" }}>
                    <SectionTitle>
                        {translate('budgetForTheFiscalYearEnding')} {forecastYear}
                    </SectionTitle>

                    <Box sx={{ width: "100%", px: 1.5 }}>
                        {!showMessage ? (
                            <Box>
                                {sectionVOList && sectionVOList?.map((item, i) => (
                                    <Grid container spacing={1}>
                                        {item.name && <Grid size={12} sx={{ backgroundColor: "#ffc107", pl: 1, my: 1 }}>
                                            <SubSectionTitle sx={{ fontSize: "20px" }}>{item.name}</SubSectionTitle>
                                        </Grid>}
                                        {item.coverSheetMetadataSectionDetails?.map((list: any, idx: React.Key) => (
                                            <>
                                                <Grid size={{ xs: 12, sm: 8, lg: 10, }}>
                                                    {list.label && list.label !== "Parishioner" && list.label !== "Non-parishioner" ? <StyledInputLabel
                                                        style={{
                                                            wordWrap: 'break-word',
                                                            overflowWrap: 'break-word',
                                                            display: 'block',
                                                            whiteSpace: 'normal',
                                                            fontSize: "18px",
                                                        }}
                                                    >
                                                        {list.label}
                                                    </StyledInputLabel> :
                                                        list.childDetails && list.childDetails.length > 0 && (
                                                            <TableContainer sx={{ mt: 1, mb: 2 }}>
                                                                <Table>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell sx={{
                                                                                backgroundColor: "#f1f1f1", fontWeight: "bold", paddingTop: 1,
                                                                                paddingBottom: 1
                                                                            }}>
                                                                                {list.label}
                                                                            </TableCell>
                                                                            {list.childDetails.map((clist: any, childidx: number) => (
                                                                                <TableCell
                                                                                    key={childidx}
                                                                                    align="center"
                                                                                    sx={{
                                                                                        fontWeight: "bold",
                                                                                        backgroundColor: "#f1f1f1", paddingTop: 1,
                                                                                        paddingBottom: 1,
                                                                                        width: `${70 / list.childDetails.length}%`
                                                                                    }}
                                                                                >
                                                                                    {clist.label}
                                                                                </TableCell>
                                                                            ))}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        <TableRow>
                                                                            <TableCell />
                                                                            {list.childDetails.map((clist: any, childidx: number) => (
                                                                                <TableCell key={childidx} align="right">
                                                                                    <NumericFormat
                                                                                        customInput={CustomTextField}
                                                                                        id={clist.shortName}
                                                                                        name={clist.shortName}
                                                                                        value={clist.value ?? ""}
                                                                                        thousandSeparator
                                                                                        placeholder="0.00"
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={false}
                                                                                        allowNegative={true}
                                                                                        onValueChange={(values) => {
                                                                                            handleFieldChange(i, clist.shortName, unformatCurrencyInput(values.value));
                                                                                        }}
                                                                                        isAllowed={(values) => {
                                                                                            const { floatValue } = values;
                                                                                            return (
                                                                                                floatValue === undefined ||
                                                                                                floatValue <= constants.MAX_AMOUNT_ALLOWED
                                                                                            );
                                                                                        }}
                                                                                        inputProps={{
                                                                                            style: {
                                                                                                textAlign: "right",
                                                                                                paddingLeft: 0,
                                                                                                marginRight: 0.1
                                                                                            },
                                                                                            onPaste: (e: any) => e.preventDefault()
                                                                                        }}
                                                                                        InputProps={{
                                                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                                                            style: { textAlign: 'right' }
                                                                                        }}
                                                                                        sx={{
                                                                                            width: list.childDetails.length < 3 ? '60%' : '100%',
                                                                                            marginLeft: 'auto'
                                                                                        }}
                                                                                        readOnly={readOnlyForecast}
                                                                                    />

                                                                                </TableCell>
                                                                            ))}
                                                                        </TableRow>
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        )}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 4, lg: 2 }}>
                                                    {list.type === "currency" && (
                                                        <NumericFormat
                                                            customInput={CustomTextField}
                                                            id={list.shortName}
                                                            name={list.shortName}
                                                            value={list.value ?? ""}
                                                            thousandSeparator
                                                            placeholder="0.00"
                                                            decimalScale={2}
                                                            fixedDecimalScale={false}
                                                            allowNegative={true}
                                                            onValueChange={(values) => {
                                                                handleFieldChange(i, list.shortName, unformatCurrencyInput(values.value));
                                                            }}
                                                            isAllowed={(values) => {
                                                                const { floatValue } = values;
                                                                return (
                                                                    floatValue === undefined ||
                                                                    floatValue <= constants.MAX_AMOUNT_ALLOWED
                                                                );
                                                            }}
                                                            inputProps={{
                                                                style: {
                                                                    textAlign: "right",
                                                                    paddingLeft: 0,
                                                                    marginRight: 0.1
                                                                },
                                                                onPaste: (e: any) => e.preventDefault()
                                                            }}
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                                style: { textAlign: 'right' }
                                                            }}
                                                            readOnly={readOnlyForecast}
                                                        />
                                                    )}
                                                    {list.type === "text" && (
                                                        <CustomTextField
                                                            value={list.value}
                                                            onChange={(e) =>
                                                                handleFieldChange(i, list.shortName, e.target.value)
                                                            }
                                                            inputProps={{
                                                                maxLength: 45
                                                            }}
                                                            readOnly={readOnlyForecast}
                                                        />
                                                    )}
                                                    {list.type === "radio" && (
                                                        <RadioGroup
                                                            value={list.value}
                                                            onChange={(e) =>
                                                                handleFieldChange(i, list.shortName, e.target.value)
                                                            }
                                                            row
                                                        >
                                                            <FormControlLabel value={1} control={<Radio sx={{ marginTop: -1 }} />} label="Yes"
                                                                disabled={readOnlyForecast} />
                                                            <FormControlLabel value={0} control={<Radio sx={{ marginTop: -1 }} />} label="No"
                                                                disabled={readOnlyForecast} />
                                                        </RadioGroup>
                                                    )}
                                                    {list.type === "date" && (
                                                        <CustomDatePicker
                                                            value={list.value && list.value.date ? dayjs(`${list.value.date.year}-${list.value.date.month}-${list.value.date.day}`) : null}
                                                            onChange={(value: any) => {
                                                                if (value) {
                                                                    const dateValue = {
                                                                        date: {
                                                                            year: value.year(),
                                                                            month: value.month() + 1,
                                                                            day: value.date()
                                                                        },
                                                                        formatted: value.format("YYYY-MM-DD")
                                                                    };
                                                                    handleFieldChange(i, list.shortName, dateValue);
                                                                }
                                                            }}
                                                            readOnly={readOnlyForecast}
                                                        />
                                                    )}



                                                </Grid>
                                            </>
                                        ))}
                                    </Grid>
                                ))}
                            </Box>
                        ) : (
                            <Box>
                                <SubSectionTitle>
                                    {translate('reportDetailsAreNotConfiguredPleaseContactTheAdministrator')}
                                </SubSectionTitle>
                            </Box>

                        )}

                        <Box className={basestyle.buttoncontainer}>
                            <ContainedButton onClick={handleBack}> {translate('back')} </ContainedButton>
                            {!(readOnlyForecast) && <ContainedButton onClick={handleSave}> {translate('save')} </ContainedButton>}
                            {!(readOnlyForecast) && <OutlinedButton onClick={handleCancel}> {translate('cancel')} </OutlinedButton>}
                            {!(readOnlyForecast) && <ContainedButton onClick={handlePrint}> {translate('print')} </ContainedButton>}
                        </Box>

                        <CancelPopUp
                            open={openPopUp}
                            popupTitle={translate('confirmCancel')}
                            handleClose={handlePopUpClose}
                            saveChanges={() => handleConfirm()}
                            message={translate('doYouWantToCancelChanges?')}
                        />

                        <Backdrop
                            sx={{
                                color: "#fff",
                                zIndex: (theme) => theme.zIndex.drawer + 1,
                                display: "flex",
                                flexDirection: "column",
                            }}
                            open={loadingFlag}
                        >
                            <CircularProgress color="inherit" />
                            <SubSectionTitle  >{translate('pleasewait')}</SubSectionTitle>
                        </Backdrop>
                    </Box>
                </StyledTwoChildContainer>
            </StyledOneChildContainer>
        </StyledParentContainer>
    );

};

export default BudgetReportView;